import React from "react";
import InquiryButton from "../InquiryButton";

const InquiryButtonContainer = () => {
  return <InquiryButton />;
};

export default InquiryButtonContainer;
